module.exports = __webpack_public_path__ + "static/media/Roboto-Light.9b4b0845.ttf";